// extracted by mini-css-extract-plugin
module.exports = {"search":"styles_search__1McX-","search-icon":"styles_search-icon__1YaCZ","search-field":"styles_search-field__3Gpwc"};